import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ icon, title, value, change, changeType, trend, color = 'var(--color-primary)' }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 transition-all duration-300 hover:shadow-elevation-4 hover:scale-[1.03] hover:-translate-y-1 cursor-pointer group">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3" style={{ backgroundColor: `${color}15` }}>
          <Icon name={icon} size={20} color={color} className="md:w-6 md:h-6 transition-transform duration-300" />
        </div>
        {trend && (
          <div className="flex items-center gap-1 px-2 py-1 rounded-md bg-muted transition-all duration-200 hover:scale-110">
            <Icon name={getChangeIcon()} size={14} className={getChangeColor()} />
            <span className={`text-xs font-medium ${getChangeColor()}`}>{change}</span>
          </div>
        )}
      </div>
      <h3 className="text-xs md:text-sm text-muted-foreground mb-1 md:mb-2 transition-colors duration-200 group-hover:text-foreground">{title}</h3>
      <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground transition-all duration-200 group-hover:scale-105">{value}</p>
    </div>
  );
};

export default MetricCard;